<template>
    <div>
        <div v-show="isShow" class="view-area">
            <table class="com-table left">
                <colgroup>
                    <col style="width: 140px" />
                    <col style="width: 570px" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>
                            강사명
                            <span class="imp">*</span>
                        </th>
                        <td>
                            <select-form
                                :disabled="isDisableSelectTeacher"
                                :select-data="[...selectFormTeacher.data]"
                                :select-value="[...selectFormTeacher.value]"
                                :selected-value="selectedTeacher"
                                class="w200"
                                @update:set="(val) => (selectedTeacher = val)"
                            ></select-form>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            반복
                            <span class="imp">*</span>
                        </th>
                        <td>
                            <div class="flex">
                                <div class="com-radio">
                                    <input
                                        id="radio-r1-1"
                                        v-model="repeat"
                                        :disabled="isModify"
                                        name="radio-r1"
                                        type="radio"
                                        value="-"
                                        @change="onChangeEditFieldMeetingRepeat"
                                    />
                                    <label for="radio-r1-1">안함</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="radio-r1-2"
                                        v-model="repeat"
                                        :disabled="isModify"
                                        name="radio-r1"
                                        type="radio"
                                        value="D"
                                        @change="onChangeEditFieldMeetingRepeat"
                                    />
                                    <label for="radio-r1-2">매일</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="radio-r1-3"
                                        v-model="repeat"
                                        :disabled="isModify"
                                        name="radio-r1"
                                        type="radio"
                                        value="W"
                                        @change="onChangeEditFieldMeetingRepeat"
                                    />
                                    <label for="radio-r1-3">매주</label>
                                </div>
                                <div class="detail-check-line">
                                    <div v-for="(wd, index) in weekdayIndex" v-show="repeat === 'W'" class="com-check">
                                        <input
                                            :id="`check-r1-${index}`"
                                            v-model="checkedDay[index]"
                                            false-value="X"
                                            name="check-r1"
                                            true-value="O"
                                            type="checkbox"
                                        />
                                        <label :for="`check-r1-${index}`">{{ wd }}</label>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            일자
                            <span class="imp">*</span>
                        </th>
                        <td>
                            <div class="com-calendar-wrap">
                                <single-calendar :date="startDate" :disabled="isModify" @update="onUpdateStartDate" />
                                <div class="com-dash"><span class="dash">~</span></div>
                                <single-calendar :date="endDate" :disabled="repeat === '-'" @update="onUpdateEndDate" />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            시간
                            <span class="imp">*</span>
                        </th>
                        <td>
                            <select-form
                                :select-data="['선택', ...selectFormTime.data]"
                                :select-value="['', ...selectFormTime.data]"
                                :selected-value="startTime"
                                class="w100"
                                @update:set="updateStartTime"
                            ></select-form>
                            <span class="dot">~</span>
                            <select-form
                                :select-data="['선택', ...selectFormTime.data, '24:00']"
                                :select-value="['', ...selectFormTime.data, '24:00']"
                                :selected-value="endTime"
                                class="w100"
                                @update:set="updateEndTime"
                            ></select-form>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            일정선택
                            <span class="imp">*</span>
                        </th>
                        <td>
                            <select-form
                                :select-data="[...selectFormMeetingType.data]"
                                :select-value="[...selectFormMeetingType.value]"
                                :selected-value="selectFormMeetingType.selectedValue"
                                class="w400"
                                @update:set="(val) => (selectFormMeetingType.selectedValue = val)"
                            ></select-form>
                        </td>
                    </tr>
                    <tr>
                        <th>직접작성</th>
                        <td>
                            <textarea
                                v-model="memo"
                                placeholder="최대 50글자까지 입력할 수 있습니다."
                                :disabled="selectFormMeetingType.selectedValue !== '-'"
                                maxlength="50"
                                class="full"
                            ></textarea>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p class="notice-txt">
                등록한 시간 동안에는 일정이 있는 것으로 간주하고 회원은 회원 예약 앱에서 [개인/OT] 를 예약할 수
                없습니다.
            </p>
            <div class="btn-line">
                <button v-if="isModify" class="com-btn" @click="checkAllowedClickEditAction(onClickBtnDeleteSchedule)">
                    일정삭제
                </button>
            </div>
            <div class="bottom-btn">
                <button class="com-btn" @click="onClickBtnCancelReservation">취소</button>
                <button v-if="!isModify" class="com-btn blue" @click="onClickBtnRegistMeeting">등록</button>
                <button v-else class="com-btn blue" @click="checkAllowedClickEditAction(onClickBtnModifyMeeting)">
                    수정
                </button>
            </div>
        </div>

        <!-- 수정정보확인 팝업 -->
        <div v-show="isShowConfirmModifyPop" class="layer-pop square-type">
            <div class="view-content w480">
                <button class="close" @click="onClickBtnCancelModify"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y info">
                    <span class="sub-title">반복 일정 수정</span>
                    <div class="com-radio">
                        <input id="radio-r4-1" v-model="modifyType" name="radio-r4" type="radio" value="1" />
                        <label for="radio-r4-1">이 일정</label>
                    </div>
                    <div class="com-radio">
                        <input id="radio-r4-2" v-model="modifyType" name="radio-r4" type="radio" value="2" />
                        <label for="radio-r4-2">이 일정 및 향후 일정</label>
                    </div>
                    <div class="com-radio">
                        <input id="radio-r4-3" v-model="modifyType" name="radio-r4" type="radio" value="0" />
                        <label for="radio-r4-3">모든 일정</label>
                    </div>
                </div>
                <div class="bottom-btn">
                    <button class="com-btn" @click="onClickBtnCancelModify">취소</button>
                    <button class="com-btn red" @click="onClickBtnConfirmModify">확인</button>
                </div>
            </div>
        </div>

        <!-- 삭제정보확인 팝업 -->
        <div v-show="isShowConfirmDeletePop" class="layer-pop square-type">
            <div class="view-content w480">
                <button class="close" @click="onClickBtnCancelDelete"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y info">
                    <span class="sub-title">반복 일정 삭제</span>
                    <div class="com-radio">
                        <input id="radio-r2-1" v-model="deleteType" name="radio-r2" type="radio" value="1" />
                        <label for="radio-r2-1">이 일정</label>
                    </div>
                    <div class="com-radio">
                        <input id="radio-r2-2" v-model="deleteType" name="radio-r2" type="radio" value="2" />
                        <label for="radio-r2-2">이 일정 및 향후 일정</label>
                    </div>
                    <div class="com-radio">
                        <input id="radio-r2-3" v-model="deleteType" name="radio-r2" type="radio" value="0" />
                        <label for="radio-r2-3">모든 일정</label>
                    </div>
                </div>
                <div class="bottom-btn">
                    <button class="com-btn" @click="onClickBtnCancelDelete">취소</button>
                    <button class="com-btn red" @click="onClickBtnConfirmDelete">확인</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import api from '@/assets/js/api';
import { Utils } from '@/assets/js/utils';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';

export default {
    name: 'TeacherScheduleDlg',
    mixins: [MixinAllowedMenu],
    computed: {
        centerId() {
            return !Utils.isEmpty(this.initCenterId) ? this.initCenterId : parseInt(this.$store.getters['auth/cId']);
        },
        isDisableSelectTeacher() {
            return !this.isAllowed('SC', 2);
        },
    },
    props: {
        initCenterId: {
            type: [Number, String],
            default: '',
        },
        selectFormTeacher: Object,
        callbackSuccess: Function,
        callbackCancel: Function,
    },
    watch: {
        /*
    repeat() {
      this.endDate = this.startDate;
    }
    */
    },
    data() {
        return {
            staffId: '',
            isModify: false,
            centerLessonScheduleId: '',
            centerLessonScheduleMasterId: '',
            selectedTeacher: '',
            masterInfo: {},
            repeat: '-',
            checkedDay: ['X', 'X', 'X', 'X', 'X', 'X', 'X'],
            startDate: moment().format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
            startTime: '',
            endTime: '',
            lessonDate: '',
            selectFormTime: {
                data: [],
                value: [],
            },
            memo: '',
            selectFormMeetingType: {
                data: ['식사', '외근', '상담', '회의', '직접작성'],
                value: ['식사', '외근', '상담', '회의', '-'],
                selectedValue: '-',
            },
            weekdayIndex: ['월', '화', '수', '목', '금', '토', '일'],
            isShow: false,
            isShowConfirmDeletePop: false,
            isShowConfirmModifyPop: false,
            deleteType: '1', // 일정삭제유형(0: 모든일정, 1: 특정일정, 2: 지정일정 이후일정까지 삭제)
            modifyType: '1', // 일정수정유형(0: 모든일정, 1: 특정일정, 2: 지정일정 이후일정까지 수정)
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.staffId = parseInt(this.$store.getters['auth/staffId']);

            const { selectFormTime } = this;

            // 시간 셋팅 : 30분 간격
            const mins = ['00', '30'];
            for (let h = 0; h < 24; h++) {
                const hour = h.toString().padStart(2, '0');
                for (const m of mins) {
                    const time = `${hour}:${m}`;
                    selectFormTime.data.push(time);
                }
            }
        },
        async onClickBtnDeleteSchedule() {
            if (this.repeat === '-') {
                // 반복일정이 아니면,
                if (confirm('이 일정을 삭제하시겠습니까?')) {
                    await this.onClickBtnConfirmDelete();
                }
            } else {
                this.isShowConfirmDeletePop = true;
            }
        },
        async onClickBtnConfirmDelete() {
            try {
                const { data } = await this.postScheduleMeetingDelete();
                this.resetData();
                this.hide();

                if (!Utils.isEmpty(this.callbackSuccess)) {
                    this.callbackSuccess();
                }
            } catch (e) {
                Utils.alertResponseErrorMessge(e);
            }
        },
        onClickBtnCancelModify() {
            this.isShowConfirmModifyPop = false;
            this.modifyType = 1;
        },
        onClickBtnCancelDelete() {
            this.isShowConfirmDeletePop = false;
            this.deleteType = 1;
        },
        onClickBtnCancelReservation() {
            if (!Utils.isEmpty(this.callbackCancel)) {
                this.callbackCancel();
            }
            this.resetData();
            this.hide();
        },
        async onClickBtnRegistMeeting() {
            if (!this.isAllowed('SC', 2) && this.selectedTeacher !== this.staffId) {
                alert('사용권한이 없습니다. 대표관리자에게 권한을 요청하세요.');
                return false;
            }

            // 값 체크 및 확인
            if (!this.validateMeetingValue()) {
                return;
            }

            if (!confirm('일정을 등록하시겠습니까?')) {
                return;
            }

            try {
                const params = this.getParams();
                const { data } = await this.postLessonScheduleMeeting(params);

                if (!Utils.isEmpty(this.callbackSuccess)) {
                    this.callbackSuccess(data);
                }
            } catch (e) {
                console.log(e);
            }
        },
        async onClickBtnModifyMeeting() {
            // 값 체크 및 확인
            if (!this.validateMeetingValue()) {
                return;
            }

            if (this.repeat === '-') {
                // 반복일정이 아니면,
                if (confirm('이 일정을 수정하시겠습니까?')) {
                    await this.onClickBtnConfirmModify();
                }
            } else {
                this.isShowConfirmModifyPop = true;
            }
        },
        async onClickBtnConfirmModify() {
            try {
                const { centerLessonScheduleMasterId } = this;

                const params = {
                    centerLessonScheduleMasterId,
                    optionType: parseInt(this.modifyType),
                    optionTargetDate: this.lessonDate.replace(/-/g, ''),
                    repeatType: this.repeat,
                    staffId: this.selectedTeacher,
                    lessonStartDate: this.startDate.replace(/-/g, ''),
                    lessonStartTime: this.startTime,
                    lessonEndDate: this.endDate.replace(/-/g, ''),
                    lessonEndTime: this.endTime,
                    centerScheduleType: this.selectFormMeetingType.selectedValue,
                    memo: this.memo ? this.memo.trim() : '',
                };

                if (params.centerScheduleType !== '-') {
                    params.memo = params.centerScheduleType;
                }

                console.log(this.modifyType, 'modifyType');
                if (params.optionType !== 0) {
                    params.centerLessonScheduleId = this.centerLessonScheduleId;
                }

                // const params = this.getParams();
                const { data } = await this.postScheduleMeetingUpdate(params);

                this.resetData();
                this.hide();

                if (!Utils.isEmpty(this.callbackSuccess)) {
                    this.callbackSuccess(data);
                }
            } catch (e) {
                console.log(e);
            }
        },
        onChangeEditFieldMeetingRepeat() {
            switch (this.repeat) {
                case '-': // 반복 안함
                    this.resetEditFieldMeetingRepeatDays();
                    // this.endDate = '';
                    this.endDate = moment().format('YYYY-MM-DD');
                    break;
                case 'D':
                    this.resetEditFieldMeetingRepeatDays();
                    break;
                case 'W':
                    break;
            }
        },

        onUpdateStartDate(date) {
            this.startDate = date;
            if (date > this.endDate || this.repeat === '-') this.endDate = date;
        },
        onUpdateEndDate(date) {
            this.endDate = date;
            if (date < this.startDate) this.startDate = date;
        },

        getCenterLessonScheduleMaster() {
            return api.get(`/admin/api/center/${this.centerId}/lesson/${this.centerLessonScheduleMasterId}`);
        },
        postLessonScheduleMeeting(params) {
            // 스웨거 검색: 직원일정 등록(비수업) 등록
            return api.post(`/admin/api/center/${this.centerId}/lesson/schedule/meeting`, { ...params });
        },
        postScheduleMeetingUpdate(params) {
            return api.put(`/admin/api/center/${this.centerId}/lesson/schedule/meeting/update`, { ...params });
        },
        postScheduleMeetingDelete() {
            const { centerLessonScheduleMasterId, centerLessonScheduleId, deleteType } = this;
            const params = {
                centerLessonScheduleMasterId,
                deleteType: parseInt(deleteType),
            };

            if (deleteType !== '0') {
                params.centerLessonScheduleId = centerLessonScheduleId;
            }

            return api.post(`/admin/api/center/${this.centerId}/lesson/schedule/meeting/delete`, { ...params });
        },
        getParams() {
            const params = {
                scheduleStaffId: this.selectedTeacher,
                schdeuleRepeatType: this.repeat,
                scheduleStartDate: this.startDate.replace(/-/g, ''),
                scheduleStartTime: this.startTime,
                scheduleEndDate: this.endDate.replace(/-/g, ''),
                scheduleEndTime: this.endTime,
                meetingType: this.selectFormMeetingType.selectedValue,
                memo: this.memo ? this.memo.trim() : '',
                scheduleRepeatWeek: this.checkedDay.join(':'),
            };

            if (Utils.isEmpty(params.schdeuleRepeatType) || params.schdeuleRepeatType === '-') {
                params.scheduleRepeatWeek = '';
                params.scheduleEndDate = params.scheduleStartDate;
            }

            return params;
        },
        validateMeetingValue() {
            if (Utils.isEmpty(this.selectedTeacher)) {
                alert('강사를 선택해주세요');
                return false;
            } else if (Utils.isEmpty(this.startDate)) {
                const msg = this.repeat !== '-' ? '시작일자를' : '일자를';
                alert(`${msg} 선택해주세요`);
                return false;
            } else if (this.repeat !== '-' && Utils.isEmpty(this.endDate)) {
                alert('종료일자를 선택해주세요');
                return false;
            } else if (Utils.isEmpty(this.startTime) || Utils.isEmpty(this.endTime)) {
                alert('시간을 선택해주세요');
                return false;
            } else if (this.selectFormMeetingType.selectedValue === '-' && Utils.isEmpty(this.memo.trim())) {
                alert('일정을 선택해주세요');
                return false;
            }

            return true;
        },
        updateStartTime(val) {
            this.startTime = val;
            this.checkEditFieldMeetingTime();
        },
        updateEndTime(val) {
            this.endTime = val;
            this.checkEditFieldMeetingTime();
        },
        checkEditFieldMeetingTime() {
            const { startTime, endTime } = this;
            if (Utils.isEmpty(startTime) || Utils.isEmpty(endTime)) {
                this.setEditFieldEndTimeAfterOneHour();
                return true;
            } else if (startTime >= endTime) {
                alert('종료시간이 시작시간보다 이전입니다.');
                this.setEditFieldEndTimeAfterOneHour();
                return false;
            }
            return true;
        },
        setEditFieldEndTimeAfterOneHour() {
            if (Utils.isEmpty(this.startTime)) {
                return;
            }

            const endTimes = this.startTime.split(':');
            const endHour = parseInt(endTimes[0]);

            // 종료시간을 1시간 뒤로 셋팅
            if (endHour === 23) {
                endTimes[0] = 24;
                endTimes[1] = '00';
            } else {
                endTimes[0] = (endHour + 1).toString().padStart(2, '0');
            }

            this.endTime = endTimes.join(':');
        },
        resetEditFieldMeetingRepeatDays() {
            const { checkedDay } = this;
            for (let i = 0; i < checkedDay.length; i++) {
                checkedDay[i] = 'X';
            }
        },
        resetData() {
            this.isModify = false;
            this.centerLessonScheduleId = '';
            this.centerLessonScheduleMasterId = '';
            this.selectedTeacher = this.staffId;
            this.repeat = '-';
            // this.startDate = '';
            this.startDate = moment().format('YYYY-MM-DD');
            // this.endDate = '';
            this.endDate = moment().format('YYYY-MM-DD');
            this.startTime = '';
            this.endTime = '';
            this.memo = '';
            this.selectFormMeetingType.selectedValue = '-';

            this.resetEditFieldMeetingRepeatDays();
        },
        async setPresetData(preset) {
            for (const key in preset) {
                switch (key) {
                    case 'meetingType':
                        this.selectFormMeetingType.selectedValue = Utils.isEmpty(preset[key]) ? '-' : preset[key];
                        break;
                    default:
                        console.log('preset', preset);
                        this[key] = preset[key];
                        break;
                }
            }

            if (!Utils.isEmpty(this.startTime) && Utils.isEmpty(this.endTime)) {
                this.setEditFieldEndTimeAfterOneHour();
            }

            if (Utils.isEmpty(this.centerLessonScheduleMasterId)) {
                return false;
            }

            try {
                this.isModify = true;
                const { data } = await this.getCenterLessonScheduleMaster();
                this.masterInfo = data;

                this.repeat = this.masterInfo.SchdeuleRepeatType;
                this.checkedDay = this.masterInfo.scheduleRepeatWeek.split(':');
                this.startDate = this.masterInfo.lessonStartDate;
                this.endDate = this.masterInfo.lessonEndDate;
            } catch (e) {
                Utils.alertResponseErrorMessge(e);
            }
        },
        checkAllowedClickEditAction(successCallback) {
            if (this.isAllowed('SC', 2) || this.selectedTeacher === this.staffId) {
                successCallback();
            } else {
                alert('사용권한이 없습니다. 대표관리자에게 권한을 요청하세요.');
                return false;
            }
        },
        show() {
            this.isShow = true;
        },
        hide() {
            this.isShow = false;
            this.isShowConfirmDeletePop = false;
            this.isShowConfirmModifyPop = false;
        },
    },
};
</script>

<style scoped></style>
